import { TABLE_PAGE_LIMIT } from 'constants/Common';

import belgiumPng from 'assets/img/Flags/belgium.png';
import bengkokPng from 'assets/img/Flags/bengkok.png';
import china from 'assets/img/Flags/china.png';
import dubaiPng from 'assets/img/Flags/dubai.png';
import hongkongPng from 'assets/img/Flags/hongkong.png';
import indiaSvg from 'assets/img/Flags/india.svg';
import israel from 'assets/img/Flags/israel.png';
import japan from 'assets/img/Flags/japan.png';
import singapore from 'assets/img/Flags/singapore.png';
import turkey from 'assets/img/Flags/turkey.png';
import usaJpg from 'assets/img/Flags/usa.jpg';

export class TableConfig {
  static PAGE_LIMIT = TABLE_PAGE_LIMIT;
  static FLAG_ICONS = { INDIA: indiaSvg, HONGKONG: hongkongPng, NEWYORK: usaJpg, DUBAI: dubaiPng, BELGIUM: belgiumPng, MUMBAIOFFICE: indiaSvg, }; // prettier-ignore
  static SORTABLE_COLUMNS = { stoneId: 'Stone No', shpNm: 'Shape', crt: 'Carat',  rap: 'Rap.($)',  ctPr: 'Amount',amt: 'Price / Carat', colNm: 'Color', clrNm: 'Clarity', }; // prettier-ignore

  static ALT_COLUMNS = ['lbNm', 'crt', 'colNm', 'clrNm', 'cutNm', 'polNm', 'symNm', 'back', 'rap', 'fluNm', ]; // prettier-ignore
  static FILTER_COLUMNS = ['colNm', 'fluNm', 'shpNm', 'shpFullNm', 'lbNm', 'clrNm', 'locNm', 'shdNm', 'cutNm', 'polNm', 'symNm', 'brlncyNm', 'blkTblNm', 'blkSdNm', 'wSdNm', 'wTblNm', 'opCrwnNm', 'opPavNm', 'opTblNm', 'eClnNm', 'girdleStr', 'cultNm', 'hANm', ]; // prettier-ignore
  static FROZEN_COLUMNS = ['lbNm', 'status', 'Details', 'vStnId', 'shpNm', 'shpFullNm', 'crt', 'colNm', 'clrNm', ]; // prettier-ignore
  static NOCHECK_COLUMNS = ['Details', 'Action', 'quote', 'expBack', 'hours', 'bidPricePerCarat', 'note', 'finalquote', 'offerDis', 'bidDiscount', 'bidAmount', ]; // prettier-ignore

  static ROUND_COLUMNS = ['amt', 'rap', ]; // prettier-ignore
  static FLOAT_COLUMNS = ['depPer', 'ratio', 'crt', 'rapAvg', 'pAng', 'pHgt', 'cHgt', 'back', 'cAng', 'fnDis', 'height', 'width', 'length', 'grdlPer', 'strLn', 'tblPer', 'lwrHal', 'ctPr', 'amt', ]; // prettier-ignore
  static TOTAL_COLUMNS = ['ctPr', 'amt', 'rap', 'crt', 'back', 'fnCtpr', 'fnAmt', ]; // prettier-ignore
}
